import axios from 'axios';

// Fill product_lot select box depending on product_id of selected recipe
const updateProductLots = function () {
  axios
    .get('/product_lots_by_recipe', {
      params: { recipe_id: $('#production_order_recipe_id').val() },
    })
    .then(response => {
      const select = $('#production_order_product_lot_id');
      select.empty();
      $.each(response.data, function (_, productLot) {
        select.append(
          $('<option>', {
            text: productLot.code_and_product,
            value: productLot.id,
          })
        );
      });
      select.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

// Fill product select box depending on product_id of selected recipe
const updateLotProducts = function () {
  axios
    .get('/products_by_recipe', {
      params: { recipe_id: $('#production_order_recipe_id').val() },
    })
    .then(response => {
      const select = $('#production_order_product_lot_attributes_product_id');
      select.empty();
      $.each(response.data, function (_, product) {
        select.append(
          $('<option>', {
            text: product.code_and_name,
            value: product.id,
          })
        );
      });
      select.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const updateLocationSelect = async target => {
  const row = $(target).parents('tr');
  const lotId = row.find('.order_locations_lot_select').val();
  const locationSelect = row.find('.order_locations_location_select');

  try {
    const res = await axios.get('/locations_by_lot.json', {
      params: { lot_id: lotId },
    });
    locationSelect.empty();
    res.data.forEach(function (location) {
      locationSelect.append(
        $('<option>', {
          text: location.warehouse_path,
          value: location.id,
        })
      );
    });
    locationSelect.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

const updateOrderEditLocationSelect = async () => {
  const locationSelect = $('.order_edit_location_select');
  const lotId = $('.order_edit_lot_select').val();

  try {
    const res = await axios.get('/locations_by_lot.json', {
      params: { lot_id: lotId },
    });
    locationSelect.empty();
    res.data.forEach(function (location) {
      locationSelect.append(
        $('<option>', {
          text: location.warehouse_path,
          value: location.id,
        })
      );
    });
    locationSelect.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

const enableRealAmountEdit = function (target) {
  const row = $(target).parents('tr');
  row.find('.current-real').hide();
  row.find('.new-real').show();
  row.find('#ingredients__modify').val('1');
  $(target).hide();
  row.find('.order-real-amount-cancel-action').show();
};

const disableRealAmountEdit = function (target) {
  const row = $(target).parents('tr');
  row.find('.current-real').show();
  row.find('.new-real').hide();
  row.find('#ingredients__modify').val('0');
  row.find('#ingredients__real').val(row.find('.current-real').html());
  $(target).hide();
  row.find('.order-real-amount-modify-action').show();
};

document.addEventListener('turbolinks:load', function () {
  if (
    document.querySelector('form.new_production_order') ||
    document.querySelector('form.edit_production_order')
  ) {
    $('#production_order_recipe_id').on('change', function () {
      updateProductLots();
    });
    $('.order_edit_lot_select').on('change', function () {
      updateOrderEditLocationSelect();
    });
  }

  if (document.querySelector('form.new_production_order')) {
    // Hide product lot select and create product lot divs
    document.querySelector('.js-select-lot').style.display = 'none';
    document.querySelector('.js-create-lot').style.display = 'none';

    // Show/hide div depending on radio buttons
    $('input[name="product_lot"]').on('change', function () {
      const selected =
        $('input:checked[name="product_lot"]').val() === 'select_lot';
      $('.js-select-lot').toggle(selected);
      $('.js-create-lot').toggle(!selected);
    });

    // Delete input from fields when changing radio button selection
    $('input[name="product_lot"]').on('click', function () {
      if ($(this).val() === 'select_lot') {
        $('#production_order_product_lot_attributes_code')
          .val('')
          .trigger('change');
      } else {
        $('#production_order_product_lot_id').val('').trigger('change');
      }
    });

    updateLotProducts();

    $('#production_order_recipe_id').on('change', function () {
      updateLotProducts();
    });

    $('#product_lot_create_lot').on('click', function () {
      document.querySelector('.production-order-lot-code').disabled = !this
        .checked;
      document.querySelector(
        '.production-order-lot-select'
      ).disabled = this.checked;
    });

    $('#product_lot_select_lot').on('click', function () {
      document.querySelector('.production-order-lot-select').disabled = !this
        .checked;
      document.querySelector(
        '.production-order-lot-code'
      ).disabled = this.checked;
    });
  }

  $('.order_locations_lot_select').on('change', function (e) {
    const target = $(e.currentTarget);
    updateLocationSelect(target);
  });

  // Modify/cancel real amount edit in request repair page
  $('.order-real-amount-modify-action').on('click', function (e) {
    const target = $(e.currentTarget);
    enableRealAmountEdit(target);
    e.preventDefault();
  });
  $('.order-real-amount-cancel-action').on('click', function (e) {
    const target = $(e.currentTarget);
    disableRealAmountEdit(target);
    e.preventDefault();
  });
});
